class SkinConcernScroll {
  constructor(container) {
    this.container = container;
    if (!this.container) return;
    
    // Check if container has any children
    if (this.container.children.length === 0) {
      this.container.style.display = 'none';
      if (this.buttonWrapper) {
        this.buttonWrapper.style.display = 'none';
      }
      return;
    }
    
    this.scrollNextButton = document.createElement('button');
    this.scrollNextButton.className = 'scroll-next-button';
    this.scrollNextButton.innerHTML = `
      <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect width="40" height="40" fill="#1C1C1C"/>
        <path d="M16 12L24 20L16 28" stroke="white" stroke-width="2"/>
      </svg>
    `;
    
    this.scrollPrevButton = document.createElement('button');
    this.scrollPrevButton.className = 'scroll-prev-button';
    this.scrollPrevButton.innerHTML = `
      <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect width="40" height="40" fill="#1C1C1C"/>
        <path d="M24 12L16 20L24 28" stroke="white" stroke-width="2"/>
      </svg>
    `;
    
    // Create a wrapper for scroll buttons
    this.buttonWrapper = document.createElement('div');
    this.buttonWrapper.className = 'scroll-button-wrapper';
    this.buttonWrapper.appendChild(this.scrollNextButton);
    this.buttonWrapper.appendChild(this.scrollPrevButton);
    this.container.parentElement.appendChild(this.buttonWrapper);
    
    this.init();
  }

  init() {
    this.addScrollListener();
    this.addScrollButtonListener();
    this.updateScrollButtonVisibility();
  }

  updateScrollButtonVisibility() {
    // Check if content is scrollable
    const isScrollable = this.container.scrollWidth > this.container.clientWidth;
    
    if (!isScrollable) {
      this.buttonWrapper.style.display = 'none';
      return;
    } else {
      this.buttonWrapper.style.display = 'block';
    }
    
    const isAtEnd = this.container.scrollLeft + this.container.clientWidth >= this.container.scrollWidth;
    const isAtStart = this.container.scrollLeft <= 0;
    
    this.scrollNextButton.style.display = isAtEnd ? 'none' : 'block';
    this.scrollPrevButton.style.display = isAtStart ? 'none' : 'block';
  }

  addScrollButtonListener() {
    this.scrollNextButton.addEventListener('click', () => {
      const scrollAmount = this.container.clientWidth;
      const targetScroll = this.container.scrollLeft + scrollAmount;
      this.container.scrollTo({
        left: targetScroll,
        behavior: 'smooth'
      });
    });

    this.scrollPrevButton.addEventListener('click', () => {
      const scrollAmount = this.container.clientWidth;
      const targetScroll = this.container.scrollLeft - scrollAmount;
      this.container.scrollTo({
        left: targetScroll,
        behavior: 'smooth'
      });
    });

    this.container.addEventListener('scroll', () => {
      this.updateScrollButtonVisibility();
    });
  }

  addScrollListener() {
    let isDown = false;
    let startX;
    let scrollLeft;

    // Prevent default drag behavior on images
    const images = this.container.querySelectorAll('img');
    images.forEach(img => {
      img.addEventListener('dragstart', (e) => e.preventDefault());
    });

    this.container.addEventListener('mousedown', (e) => {
      isDown = true;
      this.container.classList.add('cursor-grabbing');
      startX = e.pageX - this.container.offsetLeft;
      scrollLeft = this.container.scrollLeft;
      e.preventDefault(); // Prevent default selection
    });

    this.container.addEventListener('mouseleave', () => {
      isDown = false;
      this.container.classList.remove('cursor-grabbing');
    });

    this.container.addEventListener('mouseup', () => {
      isDown = false;
      this.container.classList.remove('cursor-grabbing');
    });

    // Mouse scroll variables

    this.container.addEventListener('mousemove', (e) => {
      if (!isDown) return;
      e.preventDefault();
      
      const x = e.pageX - this.container.offsetLeft;
      const walk = (x - startX) * 2;
      this.container.scrollLeft = scrollLeft - walk;
    });




    // Touch events for mobile
    this.container.addEventListener('touchstart', (e) => {
      startX = e.touches[0].pageX - this.container.offsetLeft;
      scrollLeft = this.container.scrollLeft;
    });

    this.container.addEventListener('touchmove', (e) => {
      if (!startX) return;
      e.preventDefault();
      const x = e.touches[0].pageX - this.container.offsetLeft;
      const walk = (x - startX) * 2;
      this.container.scrollLeft = scrollLeft - walk;
    });

    this.container.addEventListener('touchend', () => {
      startX = null;
    });

    this.container.addEventListener('touchcancel', () => {
      startX = null;
    });
  }
}

// Initialize all scroll instances
window.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.skin-concern-scroll').forEach(container => {
    new SkinConcernScroll(container);
  });
});